import React, { createContext, useContext, useState, useEffect, useRef, Children} from 'react'

export const AuthSkillContext = createContext(null)

export function useAuth() {
  return useContext(AuthSkillContext);
}

export const AuthSkillProvider = ({ children }) => {
  const [ currentUser, setCurrentUser] = useState(null)

  useEffect(() => {

  },[])

  const setUser = (user) =>{
    setCurrentUser(user)
  }
  
  const test = (test) =>{
    console.log(test)
  }

  

  return (
    <AuthSkillContext.Provider value={{ setUser, currentUser, test }}>
      {children}
    </AuthSkillContext.Provider>
  );
}

